export enum RATING_VALUE {
  EXCELLENT = 'excellent',
  VERY_GOOD = 'verygood',
  GOOD = 'good',
  PLEASANT = 'pleasant',
}

export const ANY_RATING_VALUE = '0';

// Raw 0-100 lower bound per bucket, for the non-evo rows and verticalFilters.
export const RATING_RAW_THRESHOLD: Record<string, number> = {
  [RATING_VALUE.EXCELLENT]: 87,
  [RATING_VALUE.VERY_GOOD]: 81,
  [RATING_VALUE.GOOD]: 75,
  [RATING_VALUE.PLEASANT]: 60,
};

type EvoRatingBucket = {
  value: string;
  score: number;
};

export const EVO_RATING_4_PLUS: EvoRatingBucket = { value: 'TY40', score: 4 };

// TripAdvisor's own bubble scores, in the order the design draws them.
export const EVO_RATING_BUCKETS: EvoRatingBucket[] = [
  { value: 'TY45', score: 4.5 },
  EVO_RATING_4_PLUS,
  { value: 'TY35', score: 3.5 },
  // { value: 'TY30', score: 3 },
];

export const ratingScoreLabel = (score: number): string => `${score.toFixed(1)}+`;

export const evoRatingScore = (value: string): number | undefined =>
  EVO_RATING_BUCKETS.find((bucket) => bucket.value === value)?.score;

// These go when the TSX filters do, along with the legacy exports above.
const LEGACY_TO_EVO = new Map<string, string>([
  [RATING_VALUE.EXCELLENT, 'TY45'],
  [RATING_VALUE.VERY_GOOD, EVO_RATING_4_PLUS.value],
  [RATING_VALUE.GOOD, 'TY35'],
  [RATING_VALUE.PLEASANT, 'TY30'],
]);

const EVO_TO_LEGACY = new Map([...LEGACY_TO_EVO].map(([legacy, evo]) => [evo, legacy]));

// Every bucket either layout can name, widest last.
const EVO_RATING_ORDER = [...LEGACY_TO_EVO.values()];

export const asEvoRatingValue = (value: string): string => LEGACY_TO_EVO.get(value) ?? value;

export const asLegacyRatingValue = (value: string): string => EVO_TO_LEGACY.get(value) ?? value;

// "Any of these" is the widest bucket asked for; one the list cannot show is wider still, so the
// filter goes rather than narrowing onto a bucket nobody chose.
export const evoSelectedRating = (rating: string | undefined): string | undefined => {
  const requested = rating?.split(',').map(asEvoRatingValue);
  if (!requested) return undefined;

  const widest = EVO_RATING_ORDER.filter((value) => requested.includes(value)).pop();
  return EVO_RATING_BUCKETS.some((bucket) => bucket.value === widest) ? widest : undefined;
};
